import { render, staticRenderFns } from "./HighlightedMessage.vue?vue&type=template&id=41e33926&scoped=true"
import script from "./HighlightedMessage.vue?vue&type=script&lang=js"
export * from "./HighlightedMessage.vue?vue&type=script&lang=js"
import style0 from "./HighlightedMessage.vue?vue&type=style&index=0&id=41e33926&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e33926",
  null
  
)

export default component.exports